import clsx from "clsx";
import React from "react";
import { TypographyProps } from "../@types/typography";

export default function Typography(
  props: TypographyProps & React.HTMLAttributes<HTMLParagraphElement>
) {
  const { type = "h6", children, className, color, ...other } = props;

  const isValidType = isValid(type);
  const currentType = isValidType ? type : "p";
  const cls = clsx(className, color && `text-${color}`, !isValidType && type);
  return React.createElement(
    currentType,
    { ...other, className: cls },
    children
  );
}

function isValid(input: string) {
  return (
    document.createElement(input).toString() != "[object HTMLUnknownElement]"
  );
}
